module.exports = __webpack_public_path__ + "img/fall.aeffb5f0.jpg";